export const BuildInfo = {timestamp:1770400966000}
